import React, { Component, useEffect, useState } from "react";
import Moment from "react-moment";
import CandidatePay from "./CandidatePay";
import config from "../../config.json";
import AddNewTimeLog from "./AddNewTimeLog";
import AddEditNotes from "./AddEditNotes";
import UploadInvoice from "./UploadInvoice";
import Swal from "sweetalert2";
import {
  formatTotalHours, getAllMonths, getAllYears, getFieldData, getFormatedNumber, getMonthLastDay,
  getMonthName, getTotalDays, getTotalHours
} from "../../services/appService";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getAlert, getConfirmAlert } from "../../services/appAlerts";
import { deleteSubcontractorTimeLogInvDoc, getSubTimeLogInvDocDeleteStatus, getTimeLogInvoice, loadTimeLogInvoice } from "../../app/store/timeLogInvoice";
import { getTimeLogDuration, getTimeLogs, getTimeLogsLoading, loadTimeLogDuration, loadTimeLogs } from "../../app/store/timeLog";
import InvoiceReview from "./InvoiceReview";
import { setCurrentPageTitle, setCurrentRoute } from "../../app/store/layoutUI";
import ViewCandidate from "./ViewCandidate";
import WorkflowElement from "../../app/components/WorkflowElement";
import { candidateBprmFormReceived, getCandidateBprmForm, loadCandidateBprmForm } from "../../app/store/candidate";
import { getAllRates, loadAllRates } from "../../app/store/rates";
import useDocDownload from "../../app/hooks/useDocDownload";

export default function CandidateInvoice(props) {
  const { mainItem, type, module } = props;

  const route = [
    { name: "Onboarding and Contracts", url: "" },
    {
      name: `${module === "Recruiter" ? "Recruiters" : "Subcontractors"}`,
      url: "/ListSubcontractor/application",
    }
  ];

  const [timeLogs, setTimeLogs] = useState([]);
  const [timeLogInvoices, setTimeLogInvoices] = useState([]);
  const [invoiceType, setInvoiceType] = useState("subcontractor");
  const [timeLogObj, setTimeLogObj] = useState("");
  const [projectStartDate, setProjectStartDate] = useState("");
  const [projectStDt, setProjectStDt] = useState("");
  const [currentStDt, setCurrentStDt] = useState("");
  const [candidateObj, setCandidateObj] = useState(null);
  const [rate, setRate] = useState(0);
  const [rateDate, setRateDate] = useState(null);
  const [perfData, setPerfData] = useState("");
  const [invRevShowHide, setInvRevShowHide] = useState(false);
  const [payShowHide, setPayShowHide] = useState(false);
  const [noteShowHide, setNoteShowHide] = useState(false);
  const [timeLogShowHide, setTimeLogShowHide] = useState(false);
  const [notesType, setNotesType] = useState("TimeLog");
  const [filterYear, setFilterYear] = useState("");
  const [filterMonth, setFilterMonth] = useState("");

  const [selectedObj, setSelectedObj] = useState("");
  const [viewType, setViewType] = useState("");
  const [editDurType, setEditDurType] = useState("");
  const [selectedKey, setSelectedKey] = useState(-1);
  const [viewShowHide, setViewShowHide] = useState(false);
  const [w2Type, setW2type] = useState(null);
  const [wfTask, setWfTask] = useState(null);
  const [wfForm, setWfForm] = useState(null);
  const [wfId, setWfId] = useState(0);
  const [allRates, setAllRates] = useState([]);

  const [viewFormType, setViewFormType] = useState("");
  const [entityType, setEntityType] = useState(null);
  const [fetchedDataType, setFetchedDataType] = useState("");
  const [updatedStateData, setUpdatedStateData] = useState(null);

  const timeLogSelector = useSelector(getTimeLogs);
  const isTimeLogsLoading = useSelector(getTimeLogsLoading);
  const timeLogsInvoiceSelector = useSelector(getTimeLogInvoice);
  const candidateBprmFormSelector = useSelector(getCandidateBprmForm);
  const timeLogDurationSelector = useSelector(getTimeLogDuration);
  const allRatesSelector = useSelector(getAllRates);
  const timeLogInvDocDeleteStatusSelector = useSelector(getSubTimeLogInvDocDeleteStatus);

  const [handleDownloadFile] = useDocDownload();

  const years = getAllYears();
  const months = getAllMonths();

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const sortTimeLogsByLatestPeriod = (logs = []) =>
    [...logs].sort((a, b) => {
      const yearDiff = (parseInt(b?.year, 10) || 0) - (parseInt(a?.year, 10) || 0);
      if (yearDiff !== 0) return yearDiff;

      return (parseInt(b?.month, 10) || 0) - (parseInt(a?.month, 10) || 0);
    });

  const getInitial = (name) => {
    if (!name || !name.trim()) return "CN";
    const words = name.trim().split(/\s+/);
    if (words.length >= 2) return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
    return name.trim().substring(0, 2).toUpperCase();
  };


  useEffect(() => {
    dispatch(setCurrentPageTitle("Candidate Invoice Detail"));
    //dispatch(setCurrentRoute(route));
  }, [])

  const state = location.state;

  useEffect(() => {
    let revewRoute = {
      name: "Review Workflow Task", url: "/ReviewTask", state: {
        task: state?.task,
        item: state?.mainItem,
        app: state?.app,
        type: 1,
        parentApplication: state?.parentApplication,
        appType: state?.appType,
        module: state?.module,
      }
    }
    const newRoute = [...route, revewRoute]
    dispatch(setCurrentRoute(newRoute));

    if (state?.item?.performerid) {
      setCandidateObj(state.item);
      setPerfData(state.item.performerData);
      dispatch(loadAllRates(state.item.performerid));
      dispatch(loadTimeLogs(state.item.performerid));
      dispatch(loadTimeLogInvoice(state.item.performerid));
      dispatch(loadTimeLogDuration(state.item.performerid));
    }

    if (state?.module === "Recruiter") {
      setInvoiceType("recruiter");
      // if (state?.item?.rates) {
      //   setRate(state.item.rates.recruiterRate);
      //   setRateDate(state.item.rates.recruiterEffectiveDate);
      // }
    }
    // else {
    //   if (state?.item?.rates) {
    //     setRate(state.item.rates.subcontractorRate);
    //     setRateDate(state.item.rates.subcontractorEffectiveDate);
    //   }
    // }
  }, []);

  useEffect(() => {
    setAllRates(allRatesSelector);
  }, [allRatesSelector])

  const getApplicableRateDetails = (item) => {
    const itemYear = parseInt(item?.year, 10);
    const itemMonth = parseInt(item?.month, 10);
    const rateField = state?.module === "Recruiter" ? "recruiterRate" : "subcontractorRate";
    const dateField = state?.module === "Recruiter" ? "recruiterEffectiveDate" : "subcontractorEffectiveDate";

    const matchedRate = Array.isArray(allRates)
      ? allRates.reduce((best, rate, index) => {
        if (!itemYear || !itemMonth) return best;

        const effMs = new Date(rate?.[dateField]).getTime();
        if (Number.isNaN(effMs)) return best;

        const effDt = new Date(effMs);
        const effYear = effDt.getFullYear();
        const effMonth = effDt.getMonth() + 1;
        const isApplicable =
          effYear < itemYear ||
          (effYear === itemYear && effMonth <= itemMonth);

        if (!isApplicable) return best;
        if (!best) return { rate, index, effMs };

        if (effMs > best.effMs) return { rate, index, effMs };
        if (effMs < best.effMs) return best;

        const addedMs = new Date(rate?.addedDateTime).getTime();
        const bestAddedMs = new Date(best.rate?.addedDateTime).getTime();
        const safeAddedMs = Number.isNaN(addedMs) ? -Infinity : addedMs;
        const safeBestAddedMs = Number.isNaN(bestAddedMs) ? -Infinity : bestAddedMs;

        if (safeAddedMs > safeBestAddedMs) return { rate, index, effMs };
        if (safeAddedMs < safeBestAddedMs) return best;

        const idNum = Number(rate?.id);
        const bestIdNum = Number(best.rate?.id);
        const safeIdNum = Number.isFinite(idNum) ? idNum : -Infinity;
        const safeBestIdNum = Number.isFinite(bestIdNum) ? bestIdNum : -Infinity;

        if (safeIdNum > safeBestIdNum) return { rate, index, effMs };
        if (safeIdNum < safeBestIdNum) return best;

        return index > best.index ? { rate, index, effMs } : best;
      }, null)?.rate
      : null;
    const fallbackRate = 0;//parseFloat(candidateRate || 0);
    const rateValue =
      matchedRate?.[rateField] !== null &&
        matchedRate?.[rateField] !== undefined &&
        matchedRate?.[rateField] !== ""
        ? parseFloat(matchedRate[rateField])
        : fallbackRate;

    const effectiveDate = matchedRate?.[dateField] || "";
    return {
      rate: rateValue,
      effectiveDate,
    };
  };

  useEffect(() => {
    setTimeLogs(sortTimeLogsByLatestPeriod(timeLogSelector));
    if (timeLogsInvoiceSelector.length > 0) {
      const filterInvoice = timeLogsInvoiceSelector.filter(x => x.invoiceType === invoiceType);
      setTimeLogInvoices(filterInvoice);
    }

    if (timeLogDurationSelector?.startDate) {
      const startDate = new Date(timeLogDurationSelector.startDate);
      startDate.setDate(startDate.getDate() + 1); // add 1 day
      const result = startDate.toISOString().substring(0, 10);
      setProjectStDt(startDate);
      setCurrentStDt(timeLogDurationSelector.projectStartedDate);
    }

  }, [timeLogSelector, timeLogsInvoiceSelector, timeLogDurationSelector]);

  useEffect(() => {

    let filterTimeLogs = [...timeLogSelector];
    if (filterYear > 0)
      filterTimeLogs = filterTimeLogs.filter(x => x.year === parseInt(filterYear));

    if (filterMonth > 0)
      filterTimeLogs = filterTimeLogs.filter(x => x.month === parseInt(filterMonth));

    setTimeLogs(sortTimeLogsByLatestPeriod(filterTimeLogs));

  }, [filterMonth, filterYear])

  const getMonthlyPeriod = (obj) => {
    if (!obj?.workingHrs || obj?.workingHrs === "") return "";
    const wt = JSON.parse(obj.workingHrs);
    const sortWt = wt.sort((a, b) => new Date(a.start) - new Date(b.start));
    if (sortWt.length > 0) {
      return (
        <div>
          <Moment format="MM/DD/YYYY">{sortWt[0].start}</Moment>-
          <Moment format="MM/DD/YYYY">
            {sortWt[sortWt.length - 1].type === "m"
              ? getMonthLastDay(sortWt[sortWt.length - 1].start)
              : sortWt[sortWt.length - 1].start}
          </Moment>
        </div>
      );
    } else {
      return "";
    }
  };

  const getFinalAmout = (obj) => {
    let fAmt = parseFloat(getInvoiceAmount(obj) || 0);

    const invItems = timeLogInvoices.filter(
      (x) => x.timeLogId === obj.id
    );

    if (invItems.length === 0) {
      return fAmt.toFixed(2);
    }

    const item = invItems[0];

    const adjMinus = parseFloat(item?.adjustmentMinues || 0);
    const adjPlus = parseFloat(item?.adjustmentPlus || 0);
    const adp = parseFloat(item?.adpDeduction || 0);

    // Apply adjustments
    fAmt = fAmt - adjMinus + adjPlus - adp;

    return fAmt.toFixed(2);
  };

  const getInvoiceAmount = (item) => {
    const totHrs = getTotalHours(item?.workingHrs || 0);
    const { rate: applicableRate } = getApplicableRateDetails(item);

    let invAmt = totHrs * applicableRate;

    // If not W2, return straight amount
    if (entType !== "W2 Basis") {
      return parseFloat(invAmt || 0).toFixed(2);
    }

    // W2 → add tax
    const taxRate = (getFieldData(perfData, "candidateonboardingform", "Tax") || 0) / 100;
    invAmt = invAmt + invAmt * taxRate;

    return parseFloat(invAmt || 0).toFixed(2);
  };

  const getInvoiceDocs1 = (item) => {
    const tmLogs = timeLogInvoices
      .filter(
        (x) =>
          x.timeLogId === item.id && x.invDoc !== null
      );
    if (tmLogs.length === 0) return "";

    if (tmLogs.length > 0) {
      return <>
        {tmLogs.map((inv) => (
          <React.Fragment>
            {inv.invoiceNumber}
            <br />
            <button
              className="btn btn-sm btn-link pl-0"
              onClick={() => handleDownloadFile(inv.invDoc)}
            >
              {inv.invDoc.documentName}
            </button>
          </React.Fragment>
        ))}
      </>
    }

  }

  const getInvoiceDocs = (item) => {
    const tmLogs = timeLogInvoices
      .filter(
        (x) =>
          x.timeLogId === item.id &&
          x.invDoc !== null
      );

    if (tmLogs.length === 0) return "";

    return <>
      {tmLogs.map((inv) => (
        <React.Fragment>
          {inv.invoiceNumber}
          <br />

          <button
            className="btn btn-sm btn-link p-0"
            onClick={() =>
              handleDownloadFile(
                inv.invDoc
              )
            }
          >
            {inv.invDoc.documentName}
          </button>
          <br />
          {inv.notes === "delete" && (
            <div className="wf-doc-row wf-doc-row-delete" style={{ marginTop: "4px" }}>
              <button
                type="button"
                className="wf-doc-link wf-btn-delete-regenerate"
                title="Delete Invoice Document"
                onClick={() => handleDeleteInvoiceDoc(inv.id)}
              >
                <i className="fa fa-trash-o" /> Delete/Regenerate
              </button>
            </div>
          )}

        </React.Fragment>
      ))}
    </>
  }

  const handleDeleteInvoiceDoc = async (id) => {
    const result = await getConfirmAlert("", "Are you sure you want to delete this document?", "error");
    if (result.isConfirmed) {
      dispatch(deleteSubcontractorTimeLogInvDoc(id))
    }
  }

  useEffect(() => {
    if (timeLogInvDocDeleteStatusSelector) {
      getAlert("", "Successfully Deleted.", "success");
      if (candidateObj?.performerid)
        dispatch(loadTimeLogInvoice(candidateObj.performerid));
    }
  }, [timeLogInvDocDeleteStatusSelector])

  const getInvoiceStatus = (item) => {

    const tmLogs = timeLogInvoices.filter(
      (x) => x.timeLogId === item.id
        && x.status !== null
    );
    if (tmLogs.length === 0) {
      return (
        <button
          type="button"
          className="wf-status-pill wf-status-pending"
          style={{ cursor: "pointer", outline: "none" }}
          onClick={() => handleInvRevShowHide(item)}
        >
          <i className="fa fa-clock-o" aria-hidden="true"></i> Review
        </button>
      );
    }

    return (
      <div className="wf-status-stack">
        {tmLogs.map((inv, index) => (
          <React.Fragment key={inv.id || index}>
            <div style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
              <button
                type="button"
                className="wf-status-pill wf-status-reviewed"
                style={{ cursor: "pointer", outline: "none" }}
                onClick={() => handleInvRevShowHide(item)}
              >
                <i className="fa fa-eye" aria-hidden="true"></i> Reviewed
              </button>
              {inv.status === true && (
                <i className="fa fa-check-circle" style={{ color: "#10b981", fontSize: "16px" }} aria-hidden="true" title="Approved" />
              )}
              {inv.status === false && (
                <i className="fa fa-times-circle" style={{ color: "#ef4444", fontSize: "16px" }} aria-hidden="true" title="Rejected" />
              )}
            </div>
            {inv.reviewDateTime && (
              <div style={{ display: "inline-flex", alignItems: "center", gap: "8px", marginTop: "4px" }}>
                <div style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "20px",
                  height: "20px",
                  borderRadius: "5px",
                  background: "#faf5ff",
                  color: "#7c3aed",
                  fontSize: "11px",
                  flexShrink: 0
                }}>
                  <i className="fa fa-calendar-o" />
                </div>
                <span style={{
                  fontSize: "13px",
                  fontWeight: 600,
                  color: "#475569",
                  lineHeight: 1
                }}>
                  <Moment format="MMM Do YYYY, h:mm a">{inv.reviewDateTime}</Moment>
                </span>
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    );
  };

  const getPaymentStatus = (item) => {
    const tmLogs = timeLogInvoices.filter(
      (x) =>
        x.timeLogId === item.id &&
        x.paymentMode !== null
    );

    if (tmLogs.length === 0) {
      return <button
        className="btn btn-link btn-sm pl-0"
        onClick={() => handlePayShowHide(item)}
      >
        To Pay
      </button>
    }

    return <>
      {tmLogs.map((pay) => (
        <React.Fragment key={pay.id}>
          <button
            className="btn btn-link btn-sm pl-0"
            onClick={() => handlePayShowHide(item)}
          >
            {pay.paymentMode !== null
              ? `Paid By IPCS ($${parseFloat(pay.paidAmount || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })})`
              : "To Pay"}
          </button>
          {pay.payDateTime && (
            <div style={{ display: "inline-flex", alignItems: "center", gap: "8px", marginTop: "4px" }}>
              <div style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: "20px",
                height: "20px",
                borderRadius: "5px",
                background: "#faf5ff",
                color: "#7c3aed",
                fontSize: "11px",
                flexShrink: 0
              }}>
                <i className="fa fa-calendar-o" />
              </div>
              <span style={{
                fontSize: "13px",
                fontWeight: 600,
                color: "#475569",
                lineHeight: 1
              }}>
                <Moment format="MMM Do YYYY, h:mm a">
                  {pay.payDateTime}
                </Moment>
              </span>
            </div>
          )}
          {pay?.docList && pay.docList.length > 0 && (
            <div style={{ marginTop: "4px" }}>
              {pay.docList.map((doc) => (
                <button
                  key={doc.documentName}
                  className="btn btn-sm btn-link p-0 d-block"
                  onClick={() =>
                    handleDownloadFile(
                      doc
                    )
                  }
                >
                  <i className="fa fa-paperclip" style={{ marginRight: "4px" }} />
                  {doc.documentName.length > 15 ? doc.documentName.substring(0, 15) + "..." : doc.documentName}
                </button>
              ))}
            </div>
          )}
        </React.Fragment>
      ))}
    </>
  }

  const getDueAmountStatus = (item) => {
    const tmLogs = timeLogInvoices
      .filter(
        (x) =>
          x.timeLogId === item.id &&
          x.paidAmount !== null
      );
    if (tmLogs.length === 0) return "";

    return <>
      {tmLogs.map((inv) => parseFloat(getFinalAmout(item) - inv.paidAmount).toFixed(2))}
    </>

  }

  const handleInvRevShowHide = (obj) => {
    if (obj === "save") {
      setInvRevShowHide(false);
      setTimeLogObj("");
      if (candidateObj?.performerid)
        dispatch(loadTimeLogInvoice(candidateObj?.performerid))
    }
    else {
      setInvRevShowHide(!invRevShowHide);
      setTimeLogObj(obj);
    }
  };

  const handleShowHide = async (obj) => {
    if (obj === "save") {
      setTimeLogShowHide(false);
      setTimeLogObj("");
      if (candidateObj?.performerid)
        dispatch(loadTimeLogs(candidateObj.performerid));
    } else {
      setTimeLogShowHide(!timeLogShowHide);
      setTimeLogObj(obj);
    }
  };

  const handlePayShowHide = async (obj) => {
    if (obj === "save") {
      setPayShowHide(false);
      setTimeLogObj("");
      if (candidateObj?.performerid)
        dispatch(loadTimeLogInvoice(candidateObj.performerid))
    } else {
      if (obj === "close") {
        setPayShowHide(false);
        setTimeLogObj("");
      } else {
        const chkInvoice = timeLogInvoices.filter(
          (x) =>
            x.timeLogId === obj.id && x.invDoc !== null
        );
        // if (chkInvoice.length > 0 || entType !== "C2C Basis") {
        if (chkInvoice.length > 0) {
          setPayShowHide(!payShowHide);
          setTimeLogObj(obj);
        } else {
          getAlert("", "Invoice not generated", "error");
        }
      }
    }
  };

  const getAdminAgencyFee = (item) => {
    const feePer = getFieldData(
      item.performerData,
      "projectengagement",
      "State_Admin_Fee"
    );

    const feeDo = getFieldData(
      item.performerData,
      "projectengagement",
      "State_Admin_Fee_Amount"
    )

    if (feePer !== "" && feePer !== "0") {
      return <>State Admin Fee : <b>{feePer}%</b></>
    }
    else if (feeDo !== "" && feeDo !== "0") {
      return <>State Admin Fee : <b>${feeDo}/hr</b></>
    }

    return "";
  }

  const handleNoteShowHide = (obj, type) => {
    if (type === "save") {
      setTimeLogObj("")
      setNoteShowHide(false);
    } else {
      setTimeLogObj(obj);
      setNoteShowHide(!noteShowHide);
    }
  };

  let item = "";
  let entType = "";
  if (candidateObj) {
    item = candidateObj;
    entType = getFieldData(
      item.performerData,
      "candidateonboardingform",
      "CandidateEntity"
    );
  }

  const handleViewShowHide = (view) => {
    // setSelectedCurrentTask("")
    setWfForm(null)
    // setEditDurType("");
    // setSelectedApp(null);
    // setEditDurType("");
    if (viewType === view) {
      setViewShowHide(false);
      setViewType("");
    } else {
      setViewType(view);
      setViewShowHide(true);
    }
  };

  const handleDurationShowHide = (obj, type, key) => {
    if (viewType === type) {
      setViewShowHide(false);
      setViewType("");
    }
  }

  const setCandidateType = (entType) => {

    let appCiid = 0;
    if (candidateObj?.applications?.length > 0) {
      const allWfTasks = candidateObj?.applications[0].workflowTasks;
      if (allWfTasks?.length > 0) {
        appCiid = allWfTasks[allWfTasks.length - 1].ciid;
      }
    }

    if (entType === "C2C Basis") {
      setWfTask({ formId: config.formIds.candidate.C2C_Basis, ciid: appCiid });
      setWfId(config.workflowsIds.candidate.C2C_Basis);
      dispatch(loadCandidateBprmForm(config.formIds.candidate.C2C_Basis))
    }
    if (entType === "W2 Basis") {
      setWfTask({ formId: config.formIds.candidate.W2_Basis, ciid: appCiid });
      setWfId(config.workflowsIds.candidate.W2_Basis);
      dispatch(loadCandidateBprmForm(config.formIds.candidate.W2_Basis));
    }
    if (entType === "1099 Basis") {
      setWfTask({ formId: config.formIds.candidate.Ten_99_Basis, ciid: appCiid });
      setWfId(config.workflowsIds.candidate.Ten_99_Basis);
      dispatch(loadCandidateBprmForm(config.formIds.candidate.Ten_99_Basis))
    }
  }

  useEffect(() => {
    if (candidateObj) {
      setUpdatedStateData(candidateObj.performerData)
    } else {
      setUpdatedStateData(null);
    }
  }, [candidateObj])

  useEffect(() => {
    setWfForm(candidateBprmFormSelector);
  }, [candidateBprmFormSelector])


  const handleViewcandidateForm = (type, item) => {
    setViewType("")
    if (viewFormType === type) {
      setViewFormType("");
      setWfForm(null)
      dispatch(candidateBprmFormReceived(null));
    } else {
      setViewFormType(type);
      setCandidateObj(item);
      const entType = getFieldData(item.performerData, "candidateonboardingform", "CandidateEntity");
      const w9type = getFieldData(item.performerData, "candidateonboardingform", "w9_Type");
      setEntityType(entType);
      setW2type(w9type);
      dispatch(candidateBprmFormReceived(null));
      setCandidateType(entType);
    }
  }

  const handleNextTask = () => {
    console.log("")
  }

  const reviewSubject = item?.performername
    ? [item.performername, item.lastName].filter(Boolean).join(" ")
    : "";

  const heroInitials = item
    ? getInitial(`${item.performername} ${item.lastName || ""}`).substring(0, 2)
    : "CN";

  const summaryHeaderEmail = item?.performeremail || "";
  const summaryHeaderPhone = item?.contactNo || "";
  const displayAppName = item?.applications?.length > 0 ? item.applications[0].applicationType : "Onboarding Application";
  const displayCiid = item?.applications?.length > 0 ? item.applications[0].ciid : "N/A";
  const onboardingStatus = item?.applications?.length > 0 && item.applications[0].appSubmitted ? "Complete" : "Review";

  return (
    <React.Fragment>
      <style>{`
        .wf-doc-row-delete {
          border-color: #fecaca !important;
          background: #fef2f2 !important;
        }
        .wf-doc-row-delete:hover {
          border-color: #fca5a5 !important;
          background: #fee2e2 !important;
          transform: translateY(-0.5px) !important;
        }
        .wf-btn-delete-regenerate {
          color: #dc2626 !important;
        }
        .wf-btn-delete-regenerate i {
          color: #dc2626 !important;
        }
        .wf-doc-row-delete:hover .wf-btn-delete-regenerate,
        .wf-doc-row-delete:hover .wf-btn-delete-regenerate i {
          color: #b91c1c !important;
        }

        /* Hero Section styles matching CandidateDetails */
        @keyframes rtFadeIn {
          from { opacity: 0; transform: translateY(8px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .rt-page {
          animation: rtFadeIn 0.28s ease both;
          --c-bg: #ffffff;
          --c-surface: #f8fafc;
          --c-canvas: #f3f6fb;
          --c-border: #e2e8f0;
          --c-border-light: #f1f5f9;
          --c-text: #0f172a;
          --c-text-2: #475569;
          --c-text-3: #94a3b8;

          --c-indigo: #2563eb;
          --c-indigo-h: #1d4ed8;
          --c-indigo-s: #eff6ff;
          --c-indigo-m: #bfdbfe;

          --c-green: #16a34a;
          --c-green-s: #f0fdf4;

          --c-amber: #d97706;
          --c-amber-s: #fffbeb;

          --c-rose: #e11d48;
          --c-rose-s: #fff1f2;

          --c-sky: #0284c7;
          --c-sky-s: #f0f9ff;

          --c-violet: #6d28d9;
          --c-violet-s: #f5f3ff;
        }

        .rt-shell {
          border: 1px solid rgba(226,232,240,0.88) !important;
          border-radius: 18px !important;
          background: #ffffff !important;
          box-shadow: 0 10px 30px -15px rgba(15,23,42,0.15) !important;
          overflow: hidden !important;
          width: 100% !important;
          box-sizing: border-box !important;
        }

        .rt-hero {
          display: grid !important;
          grid-template-columns: 1fr auto !important;
          align-items: stretch !important;
          gap: 20px !important;
          padding: 20px !important;
          background: linear-gradient(135deg, rgba(239,246,255,0.9) 0%, #ffffff 46%, #f8fafc 100%) !important;
          border-bottom: 1px solid var(--c-border-light) !important;
          position: relative !important;
          overflow: hidden !important;
          box-sizing: border-box !important;
        }

        .rt-hero::before {
          content: "" !important;
          position: absolute !important;
          inset: 0 0 auto 0 !important;
          height: 3px !important;
          background: linear-gradient(90deg, #2563eb, #10b981, #eab308) !important;
        }

        .rt-hero-left {
          display: flex !important;
          gap: 16px !important;
          align-items: flex-start !important;
          min-width: 260px !important;
          flex: 1 1 360px !important;
          position: relative !important;
          z-index: 1 !important;
        }

        .rt-hero-main {
          flex: 1 !important;
          min-width: 0 !important;
        }

        .rt-hero-icon {
          width: 52px !important;
          height: 52px !important;
          border-radius: 14px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: #1d4ed8 !important;
          background: #ffffff !important;
          border: 1px solid #bfdbfe !important;
          font-size: 15px !important;
          font-weight: 900 !important;
          letter-spacing: 0.03em !important;
          flex-shrink: 0 !important;
          box-shadow: 0 10px 24px rgba(37,99,235,0.12) !important;
          position: relative !important;
        }

        .rt-hero-icon-badge {
          position: absolute !important;
          right: -5px !important;
          bottom: -5px !important;
          width: 20px !important;
          height: 20px !important;
          border-radius: 50% !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          background: #2563eb !important;
          color: #ffffff !important;
          border: 2px solid #ffffff !important;
          font-size: 9px !important;
          box-shadow: 0 4px 8px rgba(37,99,235,0.2) !important;
        }

        .rt-kicker {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          margin: 0 0 8px !important;
          color: #1d4ed8 !important;
          font-size: 10px !important;
          font-weight: 800 !important;
          letter-spacing: 0.08em !important;
          text-transform: uppercase !important;
          background: #eff6ff !important;
          border: 1px solid #bfdbfe !important;
          border-radius: 999px !important;
          padding: 4px 9px !important;
        }

        .rt-title {
          font-size: 20px !important;
          font-weight: 900 !important;
          color: var(--c-text) !important;
          margin: 0 !important;
          line-height: 1.15 !important;
          letter-spacing: 0 !important;
        }

        .rt-subtitle {
          font-size: 11px !important;
          color: #64748b !important;
          margin: 7px 0 0 !important;
          max-width: 620px !important;
          line-height: 1.45 !important;
        }

        .rt-hero-highlights {
          display: flex !important;
          align-items: center !important;
          gap: 8px !important;
          flex-wrap: wrap !important;
          margin-top: 12px !important;
        }

        .rt-hero-highlight {
          display: inline-flex !important;
          align-items: center !important;
          gap: 7px !important;
          padding: 7px 10px !important;
          border-radius: 8px !important;
          background: rgba(255,255,255,0.82) !important;
          border: 1px solid #e2e8f0 !important;
          color: #334155 !important;
          font-size: 10px !important;
          font-weight: 800 !important;
          box-shadow: 0 2px 6px rgba(15,23,42,0.03) !important;
        }

        .rt-hero-highlight i {
          color: #2563eb !important;
          font-size: 11px !important;
        }

        .rt-actions {
          display: flex !important;
          flex-direction: column !important;
          align-items: flex-end !important;
          gap: 12px !important;
          min-width: 320px !important;
          position: relative !important;
          z-index: 1 !important;
        }

        .rt-app-card {
          display: flex !important;
          align-items: center !important;
          gap: 16px !important;
          padding: 16px 20px !important;
          background: #ffffff !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 16px !important;
          width: 100% !important;
          max-width: 380px !important;
          transition: all 0.2s ease-in-out !important;
          box-shadow: 0 4px 12px rgba(15, 23, 42, 0.03) !important;
        }

        .rt-app-card:hover {
          background: #f8fafc !important;
          border-color: #cbd5e1 !important;
          box-shadow: 0 6px 16px rgba(15, 23, 42, 0.06) !important;
        }

        .rt-app-card-left {
          display: flex !important;
          align-items: center !important;
          gap: 16px !important;
          min-width: 0 !important;
          flex: 1 !important;
        }

        .rt-app-card-icon {
          width: 48px !important;
          height: 48px !important;
          border-radius: 12px !important;
          background: linear-gradient(135deg, #0f766e 0%, #2563eb 100%) !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: #ffffff !important;
          font-size: 20px !important;
          flex-shrink: 0 !important;
          box-shadow: 0 4px 8px rgba(37, 99, 235, 0.15) !important;
        }

        .rt-app-card-info {
          display: flex !important;
          flex-direction: column !important;
          min-width: 0 !important;
        }

        .rt-app-card-label {
          font-size: 10px !important;
          font-weight: 700 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.06em !important;
          color: #64748b !important;
          margin-bottom: 4px !important;
        }

        .rt-app-card-title {
          font-size: 15px !important;
          font-weight: 850 !important;
          color: #0f172a !important;
          margin: 0 0 4px 0 !important;
          word-break: break-word !important;
        }

        .rt-app-card-meta {
          display: flex !important;
          align-items: center !important;
          gap: 16px !important;
          font-size: 13px !important;
          color: #475569 !important;
          font-weight: 600 !important;
        }

        .rt-app-card-ciid {
          color: #475569 !important;
          font-weight: 600 !important;
        }

        .rt-app-card-status {
          display: inline-flex !important;
          align-items: center !important;
          gap: 4px !important;
          color: #0f172a !important;
        }

        .rt-pill {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          padding: 4px 10px !important;
          border-radius: 99px !important;
          font-size: 11px !important;
          font-weight: 700 !important;
          white-space: nowrap !important;
          transition: all 0.15s ease !important;
          border: 1px solid #e2e8f0 !important;
          background: #ffffff !important;
          color: #475569 !important;
        }
        .rt-pill i {
          font-size: 11px !important;
        }
        .rt-pill.success {
          background: #ecfdf5 !important;
          border-color: #a7f3d0 !important;
          color: #065f46 !important;
        }
        .rt-pill.success i {
          color: #10b981 !important;
        }
        .rt-pill.warning {
          background: #fffbeb !important;
          border-color: #fde68a !important;
          color: #b45309 !important;
        }
        .rt-pill.warning i {
          color: #f59e0b !important;
        }

        /* Premium UI Style enhancements matching CandidateDetails */
        .back-btn-container {
          display: flex !important;
          justify-content: flex-end !important;
          margin-bottom: 15px !important;
        }

        .back-btn-modern {
          display: inline-flex !important;
          align-items: center !important;
          gap: 8px !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          color: #475569 !important;
          font-size: 13px !important;
          font-weight: 700 !important;
          padding: 8px 16px !important;
          border-radius: 8px !important;
          transition: all 0.15s ease !important;
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05) !important;
          cursor: pointer !important;
          outline: none !important;
        }

        .back-btn-modern:hover {
          background: #f8fafc !important;
          border-color: #94a3b8 !important;
          color: #1e293b !important;
          transform: translateY(-1px) !important;
        }

        .back-btn-modern i {
          font-size: 12px !important;
          transition: transform 0.15s ease !important;
        }

        .back-btn-modern:hover i {
          transform: translateX(-2px) !important;
        }

        .wf-candidate-card-new {
          background: #ffffff !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 16px !important;
          padding: 24px !important;
          box-shadow: 0 4px 20px rgba(15, 23, 42, 0.03) !important;
          margin-bottom: 24px !important;
        }

        .wf-cc-header {
          display: flex !important;
          justify-content: space-between !important;
          align-items: flex-start !important;
          border-bottom: 1px solid #f1f5f9 !important;
          padding-bottom: 16px !important;
          margin-bottom: 16px !important;
          flex-wrap: wrap !important;
          gap: 16px !important;
        }

        .wf-cc-status {
          display: flex !important;
          align-items: center !important;
        }

        .badge-capsule {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 4px 10px !important;
          border-radius: 20px !important;
          font-size: 12px !important;
          font-weight: 600 !important;
          line-height: 1 !important;
        }

        .badge-capsule-modern {
          background: rgba(37, 99, 235, 0.06) !important;
          color: #2563eb !important;
          border: 1px solid rgba(37, 99, 235, 0.15) !important;
        }

        .badge-capsule-success {
          background: rgba(16, 185, 129, 0.08) !important;
          color: #047857 !important;
          border: 1px solid rgba(16, 185, 129, 0.15) !important;
        }

        .badge-capsule-pending {
          background: rgba(245, 158, 11, 0.08) !important;
          color: #b45309 !important;
          border: 1px solid rgba(245, 158, 11, 0.15) !important;
        }

        .wf-cc-grid {
          display: grid !important;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)) !important;
          gap: 20px !important;
        }

        .wf-cc-block {
          background: #f8fafc !important;
          border: 1px solid #f1f5f9 !important;
          border-radius: 12px !important;
          padding: 16px !important;
        }

        .wf-cc-block-title {
          font-size: 11px !important;
          font-weight: 700 !important;
          color: #475569 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.5px !important;
          margin-bottom: 12px !important;
          display: flex !important;
          align-items: center !important;
          gap: 6px !important;
        }

        .wf-cc-block-title i {
          color: #3b82f6 !important;
          font-size: 13px !important;
        }

        .wf-cc-block-content {
          display: flex !important;
          flex-direction: column !important;
          gap: 8px !important;
        }

        .wf-cc-detail-row {
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          font-size: 12.5px !important;
          color: #475569 !important;
          gap: 8px !important;
        }

        .wf-cc-detail-row span {
          color: #64748b !important;
        }

        .wf-cc-detail-row strong {
          color: #1e293b !important;
          font-weight: 600 !important;
        }

        .wf-identity-cell {
          display: flex !important;
          align-items: flex-start !important;
          gap: 12px !important;
          min-width: 0 !important;
        }

        .wf-avatar-stack {
          display: flex !important;
          flex-direction: column !important;
          align-items: center !important;
          gap: 6px !important;
          flex-shrink: 0 !important;
        }

        .wf-avatar-circle {
          width: 40px !important;
          height: 40px !important;
          border-radius: 12px !important;
          background: linear-gradient(135deg, #0f766e 0%, #2563eb 100%) !important;
          color: #ffffff !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          font-size: 15px !important;
          font-weight: 700 !important;
          letter-spacing: 0.5px !important;
          flex: 0 0 auto !important;
          box-shadow: 0 4px 10px rgba(15, 118, 110, 0.2) !important;
          border: 2px solid #ffffff !important;
          outline: 1px solid #e2e8f0 !important;
        }

        .wf-inline-id {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 2px 6px !important;
          border-radius: 6px !important;
          font-size: 9.5px !important;
          font-weight: 700 !important;
          color: #475569 !important;
          background: #f1f5f9 !important;
          border: 1px solid #e2e8f0 !important;
          line-height: 1 !important;
        }

        .wf-identity-copy {
          display: flex !important;
          flex-direction: column !important;
          gap: 3px !important;
          min-width: 0 !important;
          flex: 1 !important;
        }

        .wf-identity-heading {
          display: flex !important;
          align-items: center !important;
          flex-wrap: wrap !important;
          gap: 8px !important;
        }

        .wf-identity-title {
          color: #0f172a !important;
          font-size: 14px !important;
          font-weight: 800 !important;
          line-height: 1.3 !important;
          letter-spacing: 0.3px !important;
          text-transform: uppercase !important;
          white-space: normal !important;
          word-break: break-word !important;
          overflow-wrap: break-word !important;
        }

        .wf-identity-meta-row {
          display: flex !important;
          align-items: flex-start !important;
          gap: 8px !important;
          color: #475569 !important;
          font-size: 12px !important;
          line-height: 1.45 !important;
        }

        .wf-identity-meta-icon {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 18px !important;
          height: 18px !important;
          border-radius: 5px !important;
          flex-shrink: 0 !important;
          font-size: 10px !important;
          margin-top: 1px !important;
        }

        .wf-identity-meta-icon i {
          color: inherit !important;
          font-size: 10px !important;
          width: auto !important;
          text-align: center !important;
          flex-shrink: 0 !important;
        }

        .wf-icon-email {
          background: #eff6ff !important;
          color: #2563eb !important;
        }

        .wf-icon-phone {
          background: #fff7ed !important;
          color: #ea580c !important;
        }

        .wf-identity-meta-text {
          font-size: 12.5px !important;
          color: #475569 !important;
        }

        /* Table Card and Table Styling */
        .wf-table-card {
          background: #ffffff !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 12px !important;
          box-shadow: 0 4px 16px rgba(15, 23, 42, 0.02) !important;
          overflow: hidden !important;
          padding: 0 !important;
          margin-bottom: 20px !important;
        }

        .wf-table {
          width: 100% !important;
          border-collapse: separate !important;
          border-spacing: 0 !important;
        }

        .wf-table-scroll {
          overflow: auto !important;
          scrollbar-width: thin;
          scrollbar-color: #94a3b8 #f1f5f9;
        }

        .wf-table-scroll::-webkit-scrollbar {
          width: 6px;
          height: 6px;
        }

        .wf-table-scroll::-webkit-scrollbar-track {
          background: #f1f5f9;
          border-radius: 999px;
        }

        .wf-table-scroll::-webkit-scrollbar-thumb {
          background: linear-gradient(180deg, #cbd5e1 0%, #94a3b8 100%);
          border-radius: 999px;
          border: 1px solid #f1f5f9;
        }

        .wf-thead {
          background: linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%) !important;
          position: sticky !important;
          top: 0 !important;
          z-index: 2 !important;
        }

        .wf-thead th {
          font-size: 11px !important;
          font-weight: 700 !important;
          color: #475569 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.6px !important;
          padding: 12px 16px !important;
          border-bottom: 2px solid #e2e8f0 !important;
          border-top: none !important;
          white-space: nowrap !important;
        }

        .wf-table-row {
          transition: background 0.15s ease, box-shadow 0.15s ease !important;
        }

        .wf-table-row:hover {
          background: linear-gradient(90deg, rgba(37,99,235,0.03) 0%, rgba(37,99,235,0.01) 100%) !important;
        }

        .wf-table td {
          padding: 12px 16px !important;
          font-size: 13px !important;
          color: #334155 !important;
          border-bottom: 1px solid #f1f5f9 !important;
          vertical-align: top !important;
        }

        .wf-table tbody tr:last-child td {
          border-bottom: none !important;
        }

        .wf-data-line {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          color: #475569;
          white-space: nowrap;
        }

        .wf-data-line i {
          color: #94a3b8;
          font-size: 11px;
        }

        .wf-empty-value {
          color: #cbd5e1;
          font-size: 11px;
          font-weight: 600;
        }

        .wf-status-stack {
          display: flex !important;
          flex-direction: column !important;
          align-items: flex-start !important;
          gap: 6px !important;
        }

        .wf-status-pill {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          min-height: 28px !important;
          padding: 4px 10px !important;
          border-radius: 999px !important;
          border: 1px solid transparent !important;
          font-size: 11.5px !important;
          font-weight: 700 !important;
          line-height: 1.2 !important;
          white-space: nowrap !important;
          transition: all 0.2s ease !important;
        }

        .wf-status-pending {
          color: #92400e !important;
          background-color: #fffbeb !important;
          border-color: #fde68a !important;
        }

        .wf-status-pending:hover {
          background-color: #fef3c7 !important;
          border-color: #fcd34d !important;
        }

        .wf-status-approved {
          color: #166534 !important;
          background-color: #f0fdf4 !important;
          border-color: #bbf7d0 !important;
        }

        .wf-status-approved:hover {
          background-color: #dcfce7 !important;
          border-color: #86efac !important;
        }

        .wf-status-rejected {
          color: #991b1b !important;
          background-color: #fef2f2 !important;
          border-color: #fecaca !important;
        }

        .wf-status-rejected:hover {
          background-color: #fee2e2 !important;
          border-color: #fca5a5 !important;
        }

        .wf-status-reviewed {
          color: #1d4ed8 !important;
          background-color: #eff6ff !important;
          border-color: #dbeafe !important;
        }

        .wf-status-reviewed:hover {
          background-color: #dbeafe !important;
          border-color: #bfdbfe !important;
        }

        .wf-status-date {
          font-size: 11px !important;
          color: #64748b !important;
          line-height: 1.4 !important;
        }
      `}</style>
      <div className="col-md-12">
        <div className="back-btn-container">
          <button
            className="back-btn-modern"
            onClick={() => {
              const state = location.state;
              if (state?.from === "/ReviewTask") {
                navigate("/ReviewTask", { state: state?.reviewTaskState });
              } else {
                navigate(-1);
              }
            }}
          >
            <i className="fa fa-arrow-left" /> Back
          </button>
        </div>
        {item !== "" && (
          <div className="rt-page mb-3">
            <div className="rt-shell mb-3">
              <div className="rt-hero">
                <div className="rt-hero-left">
                  <div className="rt-hero-icon">
                    {heroInitials}
                    <span className="rt-hero-icon-badge">
                      <i className="fa fa-user" aria-hidden="true" />
                    </span>
                  </div>
                  <div className="rt-hero-main">
                    <div className="rt-kicker">
                      <i className="fa fa-id-card-o" aria-hidden="true" />
                      Candidate Time Log & Invoice Detail
                    </div>
                    <h1 className="rt-title">{reviewSubject}</h1>
                    <p className="rt-subtitle">
                      Review and manage onboarding workflow tasks for{" "}
                      {reviewSubject}.
                    </p>
                    <div className="rt-hero-highlights">
                      {item?.performerid && (
                        <div className="rt-hero-highlight" style={{ background: "#f1f5f9", borderColor: "#e2e8f0" }}>
                          <span style={{ fontWeight: "700", color: "#475569", marginRight: "4px" }}>CID:</span>
                          #{item.performerid}
                        </div>
                      )}
                      {item?.maxloans && (
                        <div className="rt-hero-highlight" style={{ background: "#ecfdf5", borderColor: "#bbf7d0", color: "#047857" }}>
                          <span style={{ fontWeight: "700", color: "#047857", marginRight: "4px" }}>IPCS:</span>
                          #{item.maxloans}
                        </div>
                      )}
                      {summaryHeaderEmail && (
                        <div className="rt-hero-highlight">
                          <i className="fa fa-envelope-o" />
                          {summaryHeaderEmail}
                        </div>
                      )}
                      {summaryHeaderPhone && (
                        <div className="rt-hero-highlight">
                          <i className="fa fa-phone" />
                          {getFormatedNumber(summaryHeaderPhone)}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="rt-actions">
                  <div className="rt-app-card">
                    <div className="rt-app-card-left">
                      <div className="rt-app-card-icon">
                        <i className="fa fa-file-text-o" />
                      </div>
                      <div className="rt-app-card-info">
                        <span className="rt-app-card-label">
                          Application Status
                        </span>
                        <span className="rt-app-card-title">{displayAppName}</span>
                        <div className="rt-app-card-meta">
                          <span className="rt-app-card-ciid"># {displayCiid}</span>
                          <span
                            className={`rt-pill ${onboardingStatus === "Complete" ? "success" : "warning"}`}
                          >
                            <i
                              className={`fa ${onboardingStatus === "Complete" ? "fa-check-circle" : "fa-clock-o"}`}
                            />
                            {onboardingStatus}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="card mb-4 shadow-none" style={{ background: 'transparent' }}>
          <div className="row">
            <div className="col-md-12 form-group">
              {item !== "" && (
                <div className="wf-candidate-card-new">
                  <div className="wf-cc-header">
                    <div className="wf-identity-cell">
                      <div className="wf-avatar-stack" style={{ position: "relative" }}>
                        <div className="wf-avatar-circle">
                          {getInitial(`${item.performername} ${item.lastName || ""}`).substring(0, 2)}
                        </div>
                        <span className="wf-inline-id">
                          #{item.performerid}
                        </span>
                      </div>
                      <div className="wf-identity-copy">
                        <div className="wf-identity-heading">
                          <button
                            onClick={() => handleViewcandidateForm("Candidate", item)}
                            className="btn p-0 btn-link btn-sm text-uppercase wf-identity-title"
                            style={{ display: "inline", padding: 0, border: "none", verticalAlign: "baseline", background: "none", textAlign: "left" }}
                          >
                            {item.performername} {item.lastName}
                          </button>
                        </div>
                        {item.maxloans && (
                          <div className="wf-identity-meta-row" style={{ margin: 0 }}>
                            <span className="wf-inline-id" style={{ background: "#ecfdf5", borderColor: "#bbf7d0", color: "#047857", fontSize: "10px", fontWeight: "700" }}>
                              IPCS: #{item.maxloans}
                            </span>
                          </div>
                        )}
                        <span className="wf-name-title" style={{ fontSize: "13px", fontWeight: "600", color: "#475569", marginTop: "2px" }}>
                          {getFieldData(item.performerData, "projectengagement", "PositionTitle") || <span className="wf-empty-value">—</span>}
                        </span>
                      </div>
                    </div>

                    <div className="wf-cc-status">
                      <span className="badge-capsule badge-capsule-modern">
                        {entType || <span className="wf-empty-value">—</span>}
                      </span>
                      <span className={`badge-capsule ${item.appSubmit ? 'badge-capsule-success' : 'badge-capsule-pending'}`} style={{ marginLeft: '8px' }}>
                        {item.appSubmit ? 'Onboarding: Done' : 'Onboarding: Pending'}
                      </span>
                    </div>
                  </div>

                  <div className="wf-cc-grid">
                    {/* Contact Info Block */}
                    <div className="wf-cc-block">
                      <div className="wf-cc-block-title"><i className="fa fa-user-circle-o" /> Candidate Info</div>
                      <div className="wf-cc-block-content">
                        {item.performeremail && (
                          <div className="wf-identity-meta-row">
                            <div className="wf-identity-meta-icon wf-icon-email">
                              <i className="fa fa-envelope-o" />
                            </div>
                            <span className="wf-identity-meta-text">{item.performeremail}</span>
                          </div>
                        )}
                        {item.contactNo && (
                          <div className="wf-identity-meta-row">
                            <div className="wf-identity-meta-icon wf-icon-phone">
                              <i className="fa fa-phone" />
                            </div>
                            <span className="wf-identity-meta-text">{getFormatedNumber(item.contactNo)}</span>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Rates & Compensation Block */}
                    <div className="wf-cc-block">
                      <div className="wf-cc-block-title"><i className="fa fa-money" /> Rates & Entity</div>
                      <div className="wf-cc-block-content">
                        {entType === "1099 Basis" && type !== "partner" && (
                          <div className="wf-cc-detail-row">
                            <span>Candidate Rate:</span>
                            <strong>${item?.rates?.candidateRate ? parseFloat(item.rates.candidateRate).toFixed(2) : "0.00"}/Hr</strong>
                          </div>
                        )}
                        {entType === "W2 Basis" && (
                          <>
                            <div className="wf-cc-detail-row">
                              <span>W9 Type:</span>
                              <strong>{getFieldData(item.performerData, "candidateonboardingform", "w9_Type") || "N/A"}</strong>
                            </div>
                            {type !== "partner" && (
                              <>
                                <div className="wf-cc-detail-row">
                                  <span>Candidate Rate:</span>
                                  <strong>${item?.rates?.candidateRate ? parseFloat(item.rates.candidateRate).toFixed(2) : "0.00"}/Hr</strong>
                                </div>
                                {getFieldData(item.performerData, "candidateonboardingform", "Per_Diem_Rate") && (
                                  <div className="wf-cc-detail-row">
                                    <span>Per Diem Rate:</span>
                                    <strong>${getFieldData(item.performerData, "candidateonboardingform", "Per_Diem_Rate")}/Day</strong>
                                  </div>
                                )}
                              </>
                            )}
                          </>
                        )}
                        {entType === "C2C Basis" && (
                          <div className="wf-cc-detail-row">
                            <span>C2C Engagement:</span>
                            <strong>Active</strong>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Agency & Client Block */}
                    <div className="wf-cc-block">
                      <div className="wf-cc-block-title"><i className="fa fa-building-o" /> Agency & Client</div>
                      <div className="wf-cc-block-content">
                        <div className="wf-cc-detail-row">
                          <span>Agency/Client:</span>
                          <button
                            className="btn btn-link btn-sm p-0 font-weight-bold"
                            onClick={() => handleViewShowHide("agency")}
                            style={{ fontSize: '13px', textAlign: 'left' }}
                          >
                            {getFieldData(item.performerData, "projectengagement", "AgencyName") || "N/A"}
                          </button>
                        </div>
                        {item.rates && !isNaN(item.rates.agencyRate) && item.rates.agencyRate !== null && (
                          <div className="wf-cc-detail-row">
                            <span>Agency Rate:</span>
                            <strong>${parseFloat(item.rates.agencyRate).toFixed(2)}/Hr</strong>
                          </div>
                        )}
                        {getAdminAgencyFee(item) && (
                          <div className="wf-cc-detail-row" style={{ marginTop: '2px' }}>
                            <span style={{ fontSize: '11px', color: '#64748b' }}>{getAdminAgencyFee(item)}</span>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Project Duration Block */}
                    <div className="wf-cc-block">
                      <div className="wf-cc-block-title"><i className="fa fa-calendar" /> Engagement Duration</div>
                      <div className="wf-cc-block-content">
                        <div className="wf-cc-detail-row">
                          <span>Duration:</span>
                          <strong>{getFieldData(item.performerData, "projectengagement", "EngagementDuration") || "0"} Months</strong>
                        </div>
                        <div className="wf-cc-detail-row">
                          <span>Start Date:</span>
                          <strong>
                            <Moment format="MMM Do YYYY">
                              {getFieldData(item.performerData, "projectengagement", "StartDate")}
                            </Moment>
                          </strong>
                        </div>
                        <div className="wf-cc-detail-row">
                          <span>End Date:</span>
                          <strong>
                            <Moment format="MMM Do YYYY">
                              {getFieldData(item.performerData, "projectengagement", "EndDate")}
                            </Moment>
                          </strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {viewType !== "" &&
                <div className="p-3 border mt-2" style={{ background: '#ffffff', borderRadius: '12px' }}>
                  <ViewCandidate
                    viewShowHide={viewShowHide}
                    handleDurationShowHide={handleDurationShowHide}
                    selectedObj={item}
                    viewType={viewType}
                  ></ViewCandidate>
                </div>}
              {wfForm && viewFormType !== "" &&
                <div className="p-3 border mt-2" style={{ background: '#ffffff', borderRadius: '12px' }}>
                  <div className="text-left mb-3 pr-0">
                    <button
                      className="btn btn-sm btn-outline-default mb-4"
                      onClick={() => handleViewcandidateForm(`${viewFormType}`, null)}
                    >
                      <i className="fa fa-times mr-2"></i>Close
                    </button>
                  </div>
                  <WorkflowElement
                    wfTask={wfTask}
                    wfForm={wfForm}
                    handleNextTask={handleNextTask}
                    viewType={true}
                    appSummary={false}
                    codeVerified={true}
                    wfTaskType={"form"}
                    updatedStateData={updatedStateData}
                  />
                </div>}
            </div>
            <div className="col-md-12">
              <div className="wf-table-card p-3 mb-3">
                <div className="row">
                  <div className="col-md-6">
                    <label htmlFor="year" className="form-control-label font-weight-bold text-muted" style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                      Year
                    </label>
                    <select
                      name="filterYear"
                      id="year"
                      className="form-control form-control-sm"
                      value={filterYear}
                      onChange={({ currentTarget }) => setFilterYear(currentTarget.value)}
                      style={{ borderRadius: '6px', height: '36px' }}
                    >
                      <option value="">All Years</option>
                      {years.map((y) => (
                        <option value={y.name}>{y.name}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="month" className="form-control-label font-weight-bold text-muted" style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                      Month
                    </label>
                    <select
                      name="filterMonth"
                      id="month"
                      className="form-control form-control-sm"
                      value={filterMonth}
                      onChange={({ currentTarget }) => setFilterMonth(currentTarget.value)}
                      style={{ borderRadius: '6px', height: '36px' }}
                    >
                      <option value="">All Months</option>
                      {months.map((m) => (
                        <option value={m.id}>{m.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12">
              <div className="wf-table-card">
                <div className="table-responsive wf-table-scroll">
                  <table className="table align-items-center wf-table">
                    <thead className="wf-thead">
                      <tr>
                        <th>Year</th>
                        <th>Month</th>
                        <th>Period & Time Logged</th>
                        <th>Hrs / Days</th>
                        <th>Rate/Hr ($)</th>
                        <th>Invoice Amount ($)</th>
                        <th>Invoice</th>
                        <th>IPCS Review / Adjustment (+,-)</th>
                        <th>Final Pay Amount ($)</th>
                        <th>Payment</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isTimeLogsLoading ? (
                        <tr>
                          <td colSpan={10} style={{ textAlign: "center", padding: "40px 20px", color: "#64748b" }}>
                            <div style={{ fontSize: "28px", marginBottom: "10px", color: "#2563eb" }}>
                              <i className="fa fa-spinner fa-spin"></i>
                            </div>
                            <div style={{ fontWeight: 600, fontSize: "15px" }}>Loading Time Logs...</div>
                            <div style={{ fontSize: "13px", color: "#94a3b8", marginTop: "4px" }}>Please wait while we fetch the latest records.</div>
                          </td>
                        </tr>
                      ) : timeLogs.length === 0 ? (
                        <tr>
                          <td colSpan={10} style={{ textAlign: "center", padding: "40px 20px", color: "#64748b" }}>
                            <div style={{ fontSize: "24px", marginBottom: "10px" }}><i className="fa fa-folder-open-o"></i></div>
                            <div style={{ fontWeight: 600, fontSize: "15px" }}>No Time Logs Found</div>
                            <div style={{ fontSize: "13px", color: "#94a3b8", marginTop: "4px" }}>There are no time logs available.</div>
                          </td>
                        </tr>
                      ) : timeLogs.map((item) => (
                        <tr key={item.id} className="wf-table-row">
                          <td>{item.year}</td>
                          <td>{getMonthName(item.month)}</td>
                          <td>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'flex-start' }}>
                              <span style={{ fontWeight: 600, color: '#334155' }}>
                                {getMonthlyPeriod(item)}
                              </span>
                              <button
                                className="btn btn-sm btn-link p-0 font-weight-bold"
                                onClick={() => handleShowHide(item)}
                                style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}
                              >
                                <i className="fa fa-eye" /> View Logs
                              </button>
                              {item.docList && item.docList.length > 0 && (
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', marginTop: '2px' }}>
                                  {item.docList.map((doc) => (
                                    <button
                                      key={doc.documentName}
                                      className="btn btn-sm btn-link p-0 text-left d-inline-flex align-items-center gap-1"
                                      onClick={() => handleDownloadFile(doc)}
                                      style={{ fontSize: '11px', color: '#64748b' }}
                                    >
                                      <i className="fa fa-paperclip" style={{ fontSize: '10px' }} />
                                      {doc.documentName.length > 15
                                        ? doc.documentName.substring(0, 15) + "..."
                                        : doc.documentName}
                                    </button>
                                  ))}
                                </div>
                              )}
                            </div>
                          </td>

                          <td>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                              <span className="wf-data-line" style={{ fontWeight: 600 }}>
                                <i className="fa fa-clock-o" /> {formatTotalHours(item?.workingHrs)}
                              </span>
                              <span style={{ fontSize: '11px', color: '#64748b', marginLeft: '17px' }}>
                                {getTotalDays(item.workingHrs) + " Days"}
                              </span>
                            </div>
                          </td>
                          <td>
                            {(() => {
                              const { rate, effectiveDate } = getApplicableRateDetails(item);
                              return (
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                                  <strong style={{ color: '#0f172a' }}>${parseFloat(rate || 0).toFixed(2)}</strong>
                                  {effectiveDate && (
                                    <div style={{ display: "inline-flex", alignItems: "center", gap: "4px", marginTop: "2px" }}>
                                      <span style={{ fontSize: "10px", fontWeight: 700, color: "#94a3b8" }}>Eff:</span>
                                      <span style={{ fontSize: "11px", fontWeight: 600, color: "#64748b" }}>
                                        <Moment format="MM/DD/YYYY">{effectiveDate}</Moment>
                                      </span>
                                    </div>
                                  )}
                                </div>
                              );
                            })()}
                          </td>

                          <td>
                            <strong style={{ color: '#0f172a' }}>${getInvoiceAmount(item)}</strong>
                          </td>

                          <td>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'flex-start' }}>
                              {getInvoiceDocs(item)}
                            </div>
                          </td>

                          <td>
                            {getInvoiceStatus(item)}
                          </td>
                          <td>
                            <strong style={{ color: '#0f172a', fontSize: '14px' }}>${getFinalAmout(item)}</strong>
                          </td>
                          <td>
                            {getPaymentStatus(item)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CandidatePay
        payShowHide={payShowHide}
        handlePayShowHide={handlePayShowHide}
        candidateObj={candidateObj}
        selectedObj={timeLogObj}
        invType={invoiceType}
        timeLogInvoices={timeLogInvoices}
        getInvoiceAmount={getInvoiceAmount}
        entType={entType}
      ></CandidatePay>

      <InvoiceReview
        invRevShowHide={invRevShowHide}
        handleInvRevShowHide={handleInvRevShowHide}
        candidateObj={candidateObj}
        selectedObj={timeLogObj}
        invType={invoiceType}
        timeLogInvoices={timeLogInvoices}
        getInvoiceAmount={getInvoiceAmount}
        entType={entType}
      ></InvoiceReview>

      <AddNewTimeLog
        showHide={timeLogShowHide}
        handleShowHide={handleShowHide}
        selectedObj={timeLogObj}
        timeLogs={timeLogs}
        allTimeLogs={timeLogs}
        candidateObj={candidateObj}
        timeLogInvoices={timeLogInvoices}
        projectStartDate={projectStDt}
      ></AddNewTimeLog>

      <AddEditNotes
        noteShowHide={noteShowHide}
        handleNoteShowHide={handleNoteShowHide}
        notesType={notesType}
        candidateObj={candidateObj}
        timeLogObj={timeLogObj}
      ></AddEditNotes>
    </React.Fragment>
  );
}
